(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wow-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wow-navigation')) {
    customElements.define('wow-navigation', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        if (this.dataset.mode === 'desktop') {
          this.details = this.querySelector('details');
          this.summary = this.querySelector('summary');
          const close = (restore = false) => {
            this.details.open = false;
            this.summary.setAttribute('aria-expanded', 'false');
            if (restore) this.summary.focus();
          };
          this.details.addEventListener('toggle', () => this.summary.setAttribute('aria-expanded', String(this.details.open)), { signal });
          this.addEventListener('keydown', event => {
            if (event.key === 'Escape' && this.details.open) { event.preventDefault(); event.stopPropagation(); close(true); }
          }, { signal });
          document.addEventListener('click', event => { if (this.details.open && !this.contains(event.target)) close(); }, { signal });
          document.addEventListener('focusin', event => { if (this.details.open && !this.contains(event.target)) close(); }, { signal });
          window.addEventListener('resize', () => { if (innerWidth < 1150) close(); }, { signal });
          window.addEventListener('pageshow', event => { if (event.persisted) close(); }, { signal });
          return;
        }
        this.dialog = this.querySelector('dialog');
        this.root = this.querySelector('[data-wow-root]');
        this.categories = this.querySelector('[data-wow-categories]');
        this.shopButton = this.querySelector('[data-wow-shop]');
        this.backButton = this.querySelector('[data-wow-back]');
        this.dialogTitle = this.querySelector('.wow-dialog-title');
        this.opener = this.closest('.shopify-section').querySelector('[aria-controls="header-sidebar-menu"]');
        this.opener.setAttribute('aria-expanded', 'false');
        this.opener.setAttribute('aria-haspopup', 'dialog');
        this.opener.addEventListener('click', event => {
          event.preventDefault();
          this.panel(false, false);
          this.dialog.showModal();
          this.previouslyLocked = document.documentElement.classList.contains('lock');
          document.documentElement.classList.add('lock');
          this.opener.setAttribute('aria-expanded', 'true');
          (this.shopButton || this.querySelector('[data-wow-close]')).focus();
        }, { signal });
        this.shopButton?.addEventListener('click', () => this.panel(true), { signal });
        this.backButton.addEventListener('click', () => this.panel(false), { signal });
        this.querySelector('[data-wow-close]').addEventListener('click', () => this.dialog.close(), { signal });
        this.dialog.addEventListener('close', () => {
          this.panel(false, false);
          this.opener.setAttribute('aria-expanded', 'false');
          if (!this.previouslyLocked) document.documentElement.classList.remove('lock');
          this.opener.focus();
        }, { signal });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const items = [...this.dialog.querySelectorAll('button,a[href],select,input,[tabindex="0"]')].filter(item => !item.disabled && item.getClientRects().length && getComputedStyle(item).visibility !== 'hidden');
          const first = items[0], last = items[items.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }, { signal });
        window.addEventListener('resize', () => { if (innerWidth >= 1150 && this.dialog.open) this.dialog.close(); }, { signal });
        window.addEventListener('pageshow', event => { if (event.persisted && this.dialog.open) this.dialog.close(); }, { signal });
      }
      panel(showShop, focus = true) {
        this.root.hidden = showShop;
        this.categories.hidden = !showShop;
        this.backButton.hidden = !showShop;
        this.dialogTitle.classList.toggle('sr-only', showShop);
        this.shopButton?.setAttribute('aria-expanded', String(showShop));
        this.querySelector('.wow-dialog-scroll').scrollTop = 0;
        if (focus) (showShop ? this.backButton : this.shopButton)?.focus();
      }
      disconnectedCallback() {
        if (this.dialog?.open) {
          this.dialog.close();
          if (!this.previouslyLocked) document.documentElement.classList.remove('lock');
        }
        this.abort?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
